export default __webpack_public_path__ + "static/media/boat.8a95d74d.gif";